// Zeitraum-Auswahl für die Selbstauskunft-Filter. Zwei nackte Datumsfelder waren im Alltag
// unbequem (User 2026-08-10) — gefragt ist ein Klick für die üblichen Fälle, das freie
// Datum bleibt als Ausweg.

export type ZeitraumPreset = 'alle' | 'heute' | 'tage7' | 'tage30' | 'monat' | 'eigen';

export const ZEITRAUM_LABEL: Record<ZeitraumPreset, string> = {
  alle: 'Alle',
  heute: 'Heute',
  tage7: '7 Tage',
  tage30: '30 Tage',
  monat: 'Dieser Monat',
  eigen: 'Zeitraum',
};

/** Presets in Knopf-Reihenfolge — 'eigen' steht am Ende und öffnet die Datumsfelder. */
export const ZEITRAUM_PRESETS: ZeitraumPreset[] = ['alle', 'heute', 'tage7', 'tage30', 'monat', 'eigen'];

const tag = (d: Date): string =>
  `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;

/** heuteIso im Format YYYY-MM-DD (die Seite reicht den lokalen Tag herein — testbar). */
export function zeitraumBereich(preset: ZeitraumPreset, heuteIso: string): { von: string; bis: string } {
  if (preset === 'alle' || preset === 'eigen') return { von: '', bis: '' };
  const heute = new Date(`${heuteIso}T12:00:00`);
  if (Number.isNaN(heute.getTime())) return { von: '', bis: '' };

  if (preset === 'heute') return { von: heuteIso, bis: heuteIso };
  if (preset === 'monat') {
    return { von: tag(new Date(heute.getFullYear(), heute.getMonth(), 1)), bis: heuteIso };
  }
  // „7 Tage" = heute und die sechs Tage davor (nicht sieben plus heute).
  const tageZurueck = preset === 'tage7' ? 6 : 29;
  const start = new Date(heute);
  start.setDate(start.getDate() - tageZurueck);
  return { von: tag(start), bis: heuteIso };
}

/** Welcher Knopf ist aktiv? Nötig, damit die Pille den gewählten Zeitraum zeigt. */
export function erkennePreset(von: string, bis: string, heuteIso: string): ZeitraumPreset {
  if (!von && !bis) return 'alle';
  for (const p of ['heute', 'tage7', 'tage30', 'monat'] as ZeitraumPreset[]) {
    const b = zeitraumBereich(p, heuteIso);
    if (b.von === von && b.bis === bis) return p;
  }
  return 'eigen';
}

/** Lesbare Kurzform für die Pillen-Zeile, z. B. „01.08. – 10.08.2026". */
export function zeitraumText(von: string, bis: string): string {
  const kurz = (iso: string, mitJahr: boolean) => {
    const d = new Date(`${iso}T12:00:00`);
    if (Number.isNaN(d.getTime())) return iso;
    const tt = String(d.getDate()).padStart(2, '0');
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    return mitJahr ? `${tt}.${mm}.${d.getFullYear()}` : `${tt}.${mm}.`;
  };
  if (!von && !bis) return 'Alle';
  if (von && !bis) return `ab ${kurz(von, true)}`;
  if (!von && bis) return `bis ${kurz(bis, true)}`;
  if (von === bis) return kurz(von, true);
  return `${kurz(von, false)} – ${kurz(bis, true)}`;
}
